import { IPromoBannerPayload, IPromoBannerRaw } from '../../interfaces/PromoBanners/IPromoBanner'
import apiService from '../Api'

export class PromoBannersService {
  async list(params?: { search?: string; page?: number; per_page?: number }) {
    return apiService.get('/promo-banners', { params }).then((res) => res.data)
  }

  async show(id: number): Promise<IPromoBannerRaw> {
    return apiService.get(`/promo-banners/${id}`).then((res) => res.data)
  }

  async create(data: IPromoBannerPayload) {
    return apiService.post('/promo-banners', data).then((res) => res.data)
  }

  async update(id: number, data: IPromoBannerPayload) {
    return apiService.put(`/promo-banners/${id}`, data).then((res) => res.data)
  }

  async delete(id: number) {
    return apiService.delete(`/promo-banners/${id}`)
  }

  async toggleActive(id: number) {
    return apiService.patch(`/promo-banners/${id}/toggle-active`).then((res) => res.data)
  }
}
